import Content from "./Content";
import ContentFactory from "./ContentFactory";
import ContentTypes from "./ContentTypes";

/**
 * ChangeEntityVisibilityContent.js
 * 
 * Created on Nov 6, 2017
 *
 * @author Olivier van der Pool for &ranj
 **/
export default class ChangeEntityVisibilityContent extends Content {
    constructor(languagePack, contentID, entityID, visible, label) {
        super(ChangeEntityVisibilityContent.NAME, ChangeEntityVisibilityContent.TYPE, label, languagePack, contentID);
        this._entityID = entityID;
        this._visible = visible;
    }

    remove() {
        this._entityID = null;
        this._visible = null;
        super.remove();
    }

    getEntityID() {
        return this._entityID;
    }

    setEntityID(value) {
        this._entityID = value;
    }

    getVisible() {
        return this._visible;
    }

    setVisible(value) {
        this._visible = value;
    }

    clone() {
        const clone = ContentFactory.getContent(ContentTypes.TYPE_CHANGE_ENTITY_VISIBILITY, this.getLanguagePack());
        clone.setContentID(this.getContentID());
        clone.setEntityID(this.getEntityID());
        clone.setVisible(this.getVisible());
        return clone;
    }

    convertToObject() {
        return this.getObject(["entityID", "visible"]);
    }
}

ChangeEntityVisibilityContent.NAME = "Change Entity Visibility";
ChangeEntityVisibilityContent.TYPE = "engChangeEntityVisibility";